import React, { memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'clsx';
import { Gallery, Section, SectionSubTitle } from 'common/components';
import { KAZAKHSTAN } from 'common/constants/region-codes';
import { WINDOWS_ELEMENT_BLOCK } from '../../windows-constants';
import { BrandName } from '../../windows-types';
import { CertificateBlock } from './certificate-block';
import {
  getWindowsTransformationGalleryList,
  IMAGE_PER_PAGE,
} from './windows-interior-gallery-section-constants';
import {
  interiorGalleryGridWithCertificate,
  interiorGalleryGrid,
} from './windows-interior-gallery-section-styles';

type WindowsInteriorGallerySectionProps = {
  brandName: BrandName | undefined;
  onConsultationSignupBtnClick: () => void;
  regionId: string;
};

export const WindowsInteriorGallerySection = memo(
  ({ brandName, onConsultationSignupBtnClick, regionId }: WindowsInteriorGallerySectionProps) => {
    const { t } = useTranslation();
    const galleryStyles = useMemo(
      () => cn(interiorGalleryGrid, { [interiorGalleryGridWithCertificate]: brandName && regionId !== KAZAKHSTAN }),
      [brandName, regionId]
    );

    const interiorGalleryList = useMemo(() => getWindowsTransformationGalleryList(Boolean(brandName)), [
      brandName,
    ]);

    return (
      <Section>
        <SectionSubTitle margin="m">{t('interior-gallery-section.title')}</SectionSubTitle>
        <Gallery
          elementBlock={WINDOWS_ELEMENT_BLOCK}
          elementText="Выполненные проекты"
          galleryGridClassName={galleryStyles}
          imageList={interiorGalleryList}
          imagePerPage={IMAGE_PER_PAGE}
          modalBtnProps={{
            onClick: onConsultationSignupBtnClick,
          }}
          renderGalleryBlock={(index: number) =>
            index === 3 && brandName && regionId !== KAZAKHSTAN && <CertificateBlock type={brandName} />
          }
          showMoreBtnLabel={t('project-gallery-section.more-button') || ''}
          modalBtnLabel={t('design-panel.button') || ''}
        />
      </Section>
    );
  }
);
